import C from "../constants/champs";


export const champs = (state = [], action) => {
    switch (action.type) {
        case C.ADD_CHAMP:
            let index = state.indexOf(state.find(champ => champ.champname === action.champ.champname));
            if(index === -1 ){
                return [...state, action.champ];
            } else {
                let champs = [...state];
                champs.splice(index, 1, action.champ);
                return [...champs];
            }

        default:
            return state;
    }
};  


// WEBPACK FOOTER //
// src/reducers/champs.jsx